<template>
    <ValidationObserver v-slot="{ invalid }">
        <EditablePanel
            class="PasswordPanel"
            title="Zmiana hasła"
            editLabel="Zmień"
            :editable="editable"
            :isLoading="isLoading"
            @edit="toggleEditing"
            @save="saveChanges(invalid)">
            <div class="fields" :class="{ editable: editable }" :key="fieldsKey">
                <ValidationProvider v-if="needsToKnowOldPassword" rules="required" v-slot="{ errors }">
                    <DefaultInputField
                        :invalid="!!errors[0]"
                        v-model="currentPassword"
                        placeholder="Obecne hasło"
                        type="password"
                        />
                    <InputError v-if="errors.length" :message="errors[0]" />
                </ValidationProvider>
                <ValidationProvider name="confirm" rules="required|min:8" v-slot="{ errors }">
                    <DefaultInputField 
                        :invalid="!!errors[0]"
                        v-model="newPassword"
                        placeholder="Nowe hasło"
                        type="password"
                        />
                    <InputError v-if="errors.length" :message="errors[0]" />
                </ValidationProvider>
                <ValidationProvider rules="required|password:@confirm" v-slot="{ errors }">
                    <DefaultInputField class="repeated-password"
                        :invalid="!!errors[0]"
                        v-model="repeatedPassword"
                        placeholder="Powtórz nowe hasło"
                        type="password"
                        />
                    <InputError v-if="errors.length" :message="errors[0]" />
                </ValidationProvider>
            </div>
        </EditablePanel>
    </ValidationObserver>

</template>

<script>
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { required, min } from 'vee-validate/dist/rules';
    import DefaultInputField from '@/components/input/DefaultInputField.vue';
    import EditablePanel from '@/components/accountView/EditablePanel.vue';
    import InputError from '../input/InputError.vue';
    import { getAuthService } from '../../services/authService';
    import { ADMIN } from '../../types/role.types';

    extend('password', {
        params: ['target'],
        validate(value, { target }) {
            return value === target;
        },
        message: 'Hasła muszą być takie same.',
    });

    extend('required', {
        ...required,
        message: 'Pole jest wymagane',
    });

    extend('min', {
        ...min,
        message: 'Hasło musi mieć przynajmniej 8 znaków.',
    });

    export default {
        name: 'PasswordPanel',
        components: {
            EditablePanel,
            DefaultInputField,
            ValidationProvider,
            ValidationObserver,
            InputError,
        },
        props: {
            editable: {
                type: Boolean,
            },
            isLoading: {
              type: Boolean,
              default: false
            }
        },
        computed: {
            needsToKnowOldPassword() {
                return this.role !== ADMIN;
            },
        },
        data() {
            return {
                role: null,
                currentPassword: '',
                newPassword: '',
                repeatedPassword: '',
                // Used to reset invalid fields.
                fieldsKey: 0,
            };
        },
        methods: {
            toggleEditing() {
                this.$emit('edit');
            },

            saveChanges(invalid) {
                if (!invalid) {
                    this.$emit('save', {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword,
                    });
                }
            },
        },
        async mounted() {
            this.$watch('editable', () => {
                if (this.editable) {
                    this.currentPassword = '';
                    this.newPassword = '';
                    this.repeatedPassword = '';
                    this.fieldsKey += 1;
                }
            });

            this.role = await getAuthService().getRole();
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/globals.scss";

    .password-popup
    {
      position: absolute;
      width: 350px;
      background-color: black;
      padding: 30px;
      border: 2px solid #d6ae5d;
      text-align: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      display: none;
      align-items: center;
      justify-content: space-around;

      div.img-wrap {

        width: 20%;

        img {
          width: 100%;
        }

        .img-success, .img-failure
        {
          display: none;
        }
      }

      // Mobile style
      @media (max-width: $phone-max-width) {

        width: 80vw;
        height: 150px;

      }

    }

    .fields {
        margin-top: 10px;
        opacity: 0;
        pointer-events: none;

        transition: 0.1s ease-out opacity;

        &.editable {
            pointer-events: unset;
            opacity: 1;
        }

        .input-field-wrapper {
            margin: 7px 0;
        }
    }


</style>
